<template>
  <div class="row justify-content-center" style="">
    <div class="col-12 col-md-10 col-lg-8 col-xl-8">
      <div class="tit text-center">
        <h2>Como nos conheceu?</h2>
      </div>
      <form @submit.prevent="submit">
        <div class="form-row">
          <div class="form-group col-12 col-md-12">
            <label for="comunicationSelect">Meio de comunicação *</label>
            <at-select ref="comunicationSelect" v-model="selectedComunication" filterable size="large" placeholder="Meio de comunicação" required>
              <at-option v-for="comunication in comunications" :key="comunication" :value="comunication">{{comunication}}</at-option>
            </at-select>
          </div>
        </div>
        
        <div class="form-row" v-if="selectedComunication == 'Outros'">
          <div class="form-group col-12 col-md-12">
            <label for="other">Qual?</label>
            <input v-model="other" id="other" class="form-control form-control-lg" type="text"/>
          </div>
        </div>
        <div class="text-center fixedOptions">
           <button class="btn btn-lg btn-primary">Próximo <img src="/static/assets/images/angle-right.svg"></button>
        </div>
      </form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/styles/iouu/mixins";

  @include xs {
    .steps {
      .form-check {
        padding-left: 0;
      }
    }

    .form-check-inline + .form-check-inline {
      margin-left: 32px;
      margin-top: 10px;
    }
  }
</style>

<script>
  export default {
    data() {
      return {
        selectedComunication: this.selectedComunication,
        comunications: [
          'Facebook',
          'Instagram',
          'Google',
          'Twitter',
          'Rádio',
          'Tv',
          'Indicação',
          'Outros'
        ],
        other: ''
      }
    },
    methods: {
      submit() {
        if(
          typeof this.selectedComunication != undefined ||
          (this.selectedComunication == 'Outros' && this.other != '')
        ){
          const newData = {
            selectedComunication: this.selectedComunication,
            other: this.other,
          }
          this.$emit('submit', newData)
        }
      },
    },
    mounted() {
      this.$refs.comunicationSelect.$el.children[0].children[2].required = true;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationInvestor/PassoComoNosConheceu.vue